import { z } from "zod";
import { orderApiResponseSchema, orderStatusResponseSchema } from "../generated-schemas";

export enum OrderStatus {
  ENTRY = "ENTRY",
  QUOTING = "QUOTING",
  WRAPPING_QUOTE = "WRAPPING_QUOTE",
  APPROVALS = "APPROVALS",
  CONFIRMING = "CONFIRMING",
  IN_PROGRESS = "IN_PROGRESS",
  TRADE_SURPLUS = "TRADE_SURPLUS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  ERROR = "ERROR",
}

export enum OrderStatusOrdering {
  ENTRY,
  QUOTING,
  WRAPPING_QUOTE,
  APPROVALS,
  CONFIRMING,
  IN_PROGRESS,
  TRADE_SURPLUS,
  COMPLETED,
  CANCELLED,
  ERROR,
}

export type OrderStatusResponse = z.infer<typeof orderStatusResponseSchema>;
export type OrderResponse = z.infer<typeof orderApiResponseSchema>;
